import { isVpnMode, playListUrl } from "../../state";
//@ts-ignore
import { createEffect, onCleanup } from "solid-js";

let API_BASE = "";

createEffect(() => {
  API_BASE = isVpnMode() ? playListUrl() : playListUrl();
});

// Watch for changes in playListUrl and update API_BASE accordingly
createEffect(() => {
  const data = playListUrl();
  API_BASE = data;
});

const basePosterSize = "w185";

export function getImageUrl(path: string, posterSize: string = basePosterSize) {
  return posterSize + path;
}

export function getImageUrlAbsolute(path: string = basePosterSize) {
  return path;
}

function _get(path: string, params: RequestInit = {}) {
  const fullUrl = API_BASE + path;
  console.log("FullUrl", fullUrl);

  const encodedUrl = btoa(fullUrl); // Encode fullUrl to base64

  const proxyUrl = localStorage.getItem("proxy_url");

  // Construct final URL based on vpnMode
  const finalUrl = isVpnMode() ? `${proxyUrl}${encodedUrl}` : fullUrl;

  return fetch(finalUrl, {
    ...params,
  }).then(r => r.json());
}

export default {
  _get,
};

// import { isVpnMode, playListUrl } from "../../state";
// //@ts-ignore
// import { createEffect, onCleanup } from "solid-js";
// import { fetchSmart } from "./providers/fetchHttpDns";

// let API_BASE = "";

// createEffect(() => {
//   API_BASE = isVpnMode() ? playListUrl() : playListUrl();
// });

// // Watch for changes in playListUrl and update API_BASE accordingly
// createEffect(() => {
//   const data = playListUrl();
//   API_BASE = data;
// });

// const basePosterSize = "w185";

// export function getImageUrl(path: string, posterSize: string = basePosterSize) {
//   return posterSize + path;
// }

// export function getImageUrlAbsolute(path: string = basePosterSize) {
//   return path;
// }

// async function _get(path: string, params: RequestInit = {}) {
//   const fullUrl = API_BASE + path;
//   console.log("FullUrl", fullUrl);

//   // Step 1: Apply VPN proxy if enabled
//   if (isVpnMode()) {
//     const encodedUrl = btoa(fullUrl); // Encode original URL to base64
//     const proxyUrl = localStorage.getItem("proxy_url");

//     if (proxyUrl) {
//       const finalUrl = `${proxyUrl}${encodedUrl}`;
//       console.log("🔒 VPN mode enabled in api._get - using proxy");
//       return fetch(finalUrl, params).then(r => r.json());
//     } else {
//       console.warn("⚠️ VPN mode enabled but no proxy_url found in localStorage");
//     }
//   }

//   // Step 2: Use fetchSmart for direct requests (handles HTTP/HTTPS + DNS smartly)
//   console.log("📞 Using fetchSmart in api._get for:", fullUrl.split("?")[0]);
//   return fetchSmart(fullUrl, params).then(r => r.json());
// }

// export default {
//   _get,
// };
